export const guideMeConfig = {
    steps: [
        {
            element: "#session-id",
            intro: "Use connection id and make the connection between westpay simulator and your client. Please provide connectionId as a header attribute."
        },
        {
            element: "#terminal-model-selection",
            intro: "You can change terminal model from here."
        },
        {
            element: "#request-sequence",
            intro: "Here will display transaction requests in sequencially."
        },
        {
            element: "#terminal-linking",
            intro: "You can manually link/unlink terminal using toggle button."
        },
        {
            element: "#terminal-connectivity",
            intro: "You can manually connect/disconnect network using this buttons."
        },
        {
            element: "#request-area",
            intro: "Once a request received to the simulator, request information will be displayed in here."
        },
        {
            element: "#basic-terminal-configuration",
            intro: "Linked terminalId, all the request validation will be done based on this."
        },
        {
            element: "#control-actions",
            intro: "You can use control button here for the manual simulation of the payment process."
        },
        {
            element: "#response-area",
            intro: "Respective response will be display here, you can check response body and header from here."
        }
    ]
}